import React from 'react';
import ReviewItem, { IReviewItem } from './item';

const ReviewGroup: React.FC<{ items: IReviewItem[] }> = ({ items }) => {
	return (
		<dl className="flex flex-col gap-5">
			{items.map((item: IReviewItem, index: number) => (
				<ReviewItem key={index} label={item.label} value={item.value} />
			))}
		</dl>
	);
};

export default ReviewGroup;
